import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { User } from '../../models/user';
import { MountPoint } from '../../models/mount-point';
import { UserService } from '../../services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { MountPointPopupComponent } from '../../pages/mount-point-popup/mount-point-popup.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-mountpoint-list',
  templateUrl: './mountpoint-list.component.html',
  styleUrl: './mountpoint-list.component.scss'
})
export class MountpointListComponent implements OnInit, OnChanges {
  @Input() user?: User;
  canEdit = false;
  action: string = '';
  loading: boolean = true;
  selectedMountPoint?: MountPoint;
  // pagination
  currentPage: number = 1;
  pageSize: number = 20;
  Math = Math;

  constructor(private userService: UserService, private dialog: MatDialog) { }

  ngOnInit() {
    if (!this.user) {
      this.retrieveUserInit();
    }  
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['user'] && this.user && (!this.user.mountPoints || this.user.mountPoints.length === 0)) {
      this.userService.getUserById(this.user.userId).subscribe(u => {
        // 只补齐 mountPoints，保持 Input 对象引用不变，避免父组件与子组件对象分离
        if (this.user) {
          this.user.mountPoints = u?.mountPoints || [];
        }
        this.selectedMountPoint = this.user?.mountPoints?.[0];
        this.loading = false;
      });
    }
  }

  retrieveUser(): void {
    this.userService.getUser().subscribe((data: User[]) => {
      this.user = data[0];
      this.selectedMountPoint = this.user?.mountPoints?.[0];
    });
  }

  retrieveUserInit(): void {
    this.userService.getUser().subscribe((data: User[]) => {
      this.user = data[0];
    });
  }

  selectMountPoint(mountPoint: MountPoint): void {
    this.selectedMountPoint = mountPoint;
    this.canEdit = false;
    this.action = 'show';
  }

  openDeleteConfirmDialog(mountPoint: MountPoint): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '360px',
      data: { title: 'Delete Mountpoint Confirmation', message: 'Are you sure you want to delete this mountpoint?' }
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteMountPoint(mountPoint);
      }
    });
  }
  
  deleteMountPoint(mountPointToDelete: MountPoint): void {
    if (!this.user) {
      console.error('User is undefined; cannot delete mountpoint');
      return;
    }

    // 过滤掉要删除的挂载点
    this.user.mountPoints = this.user.mountPoints.filter(mountPoint => mountPoint !== mountPointToDelete);
    this.selectedMountPoint = this.user?.mountPoints?.[0];
    // 同步页码与统计
    this.currentPage = 1;
  }

  onBack(): void {
    this.canEdit = false;
    this.action = '';
    this.loading = false;
  }

  openEditDialog(mountPoint: MountPoint): void {
    const dialogRef = this.dialog.open(MountPointPopupComponent, {
      width: '800px',
      data: {mountPoint: mountPoint}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  // expose helpers for parent header buttons
  openEditSelected(): void {
    if (this.selectedMountPoint) this.openEditDialog(this.selectedMountPoint);
  }
  triggerDeleteSelected(): void {
    if (this.selectedMountPoint) this.openDeleteConfirmDialog(this.selectedMountPoint);
  }

  // pagination helpers
  get totalPages(): number {
    const total = this.user?.mountPoints?.length || 0;
    return total === 0 ? 0 : Math.ceil(total / this.pageSize);
  }
  get pageWindow(): number[] {
    const total = this.totalPages;
    if (total <= 0) return [];
    const targetCount = Math.min(5, total);
    const windowRadius = Math.floor(targetCount / 2);
    let start = Math.max(1, this.currentPage - windowRadius);
    let end = Math.min(total, start + targetCount - 1);
    start = Math.max(1, Math.min(start, end - targetCount + 1));
    const pages: number[] = [];
    for (let p = start; p <= end; p++) pages.push(p);
    return pages;
  }
  get pagedMountPoints(): MountPoint[] {
    const all = this.user?.mountPoints || [];
    const start = (this.currentPage - 1) * this.pageSize;
    return all.slice(start, start + this.pageSize);
  }
  goToPage(p: number): void { this.currentPage = Math.min(Math.max(1, p), this.totalPages); }
  goFirst(): void { this.goToPage(1); }
  goLast(): void { this.goToPage(this.totalPages); }
  goPrev(): void { if (this.currentPage > 1) this.currentPage--; }
  goNext(): void { if (this.currentPage < this.totalPages) this.currentPage++; }
}

